import { i18n } from '@/lang';

export const LUDUM_DRV_IMPORTS = {
    PROFILE: 1,
    STEP_TEST: 2,
    VO2_TEST: 3,
    K2_TEST: 4,
    K6_TEST: 5,
    K5_TEST: 6
};

export const LUDUM_HEALTH_STATUSES = {
    HEALTHY: 1,
    INJURED: 2,
    ILL: 3
};

export const LUDUM_INTENSITIES = {
    UT1: 1,
    UT2: 2,
    UT3: 3,
    AT: 4,
    TR: 5,
    LACTATE_TOLERANCE: 6,
    A_LACT: 7
};

export const LUDUM_SUBSCRIPTION_FEATURES = {
    MORNING_MONITORING: 1,
    IMPORTS: 2,
    GPS_HR: 3,
    TRAINING_SCORE: 4,
    ADDITIONAL_REPORTS: 5,
    GMT: 6,
    RPE: 7,
    WEEKLY_SUMMARY: 8,
    NON_COMPETITIVE: 9,
    DRV: 10,
    RACING_REPORT: 16,
    LIVE_RESULTS: 17,
    PERFORMANCE_REPORT: 18,
    IMPROVEMENT_REPORT: 19,
    ANALYSIS_REPORT: 20,
    COMPARISON_REPORT: 21,
    LIVE_RESULTS_CONTROLS: 22,
    STROKE_RATE_INTENSITIES: 23,
    PADDLING_GMT: 24,
    CONNECT_EQUIPMENT: 25,
    CREW_QR_CODES: 26,
    TELEMETRY: 27,
    CHALLENGES: 28,
    THIRD_PARTY_INTEGRATIONS: 29
};

export const LUDUM_SUBSCRIPTION_PLANS = {
    FREE_TRIAL: 1,
    INDIVIDUAL_FREE: 2,
    INDIVIDUAL: 3,
    PERFORMANCE: 4,
    PERFORMANCE_UNLIMITED: 5,
    ORGANISATION: 6,
    ORGANISATION_UNLIMITED: 7,
    DRV: 8,
    ROWING_AUSTRALIA: 9,
    BRONZE: 10,
    BRONZE_UNLIMITED: 11,
    SILVER: 12,
    SILVER_UNLIMITED: 13,
    GOLD: 14,
    GOLD_UNLIMITED: 15,
    GOLD_WITH_RECORDING_CONTROLS: 16,
    BRITISH_ROWING: 17,
    PLATINUM_UNLIMITED: 18,
    TELEMETRY_UNLIMITED: 19,
    PLATINUM: 20,
    TELEMETRY_UNAVAILABLE: 21
};

export const LUDUM_SUBSCRIPTION_STATUS = {
    PENDING: 1,
    ACTIVE: 2,
    CANCELED: 3
};

export const LUDUM_THIRD_PARTY_IDS = {
    GARMIN: 1,
    POLAR: 2,
    SUUNTO: 3,
    FLOAT: 4,
    LZMA: 5,
    STRAVA: 6,
    APPLE_HEALTH: 8
};
export const LUDUM_MESSAGE_TYPE = {
    SUCCESS: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4
};

export const LUDUM_USER_ROLES = {
    ATHLETE: 2,
    HEAD_COACH: 3,
    MANAGER: 5,
    COACH: 6
};

export const LUDUM_USER_STATUSES = {
    PENDING: 0,
    APPROVED: 1, // active
    REJECTED: 2,
    LEFT: 3,
    INVITED: 4, // active
    ATHLETE_REJECTED: 5,
    ONBOARDING: 6 // active
};

export const RESULT_CONSTRAINTS = {
    fullDigitTime: {
        mask: '##:##:##.###',
        format: 'HH:mm:ss.SSS',
        placeholder: '00:00:00.000'
    },
    singleDigitMinutes: {
        mask: '#:##.#',
        format: 'm:ss.S',
        placeholder: '0:00.0'
    },
    doubleDigitMinutes: {
        mask: '##:##',
        format: 'mm:ss',
        placeholder: '00:00'
    },
    doubleDigitMinutesSeconds: {
        mask: '##:##.#',
        format: 'mm:ss.S',
        placeholder: '00:00.0'
    },
    doubleDigitMinutesSecondsMillis: {
        mask: '##:##.##',
        format: 'mm:ss.SSS',
        placeholder: '00:00.00'
    },
    doubleDigitHours: {
        mask: '##:##:##.#',
        format: 'HH:mm:ss.S',
        placeholder: '00:00:00.0'
    },
    singleDigitHours: {
        mask: '#:##:##.#',
        format: 'H:mm:ss.S',
        placeholder: '0:00:00.0'
    },
    hoursMinutesSeconds: {
        mask: '##:##:##',
        format: 'HH:mm:ss',
        placeholder: '00:00:00'
    },
    hoursMinutes: {
        mask: '##:##',
        format: 'HH:mm',
        placeholder: '00:00'
    },
    hourMinutes: {
        mask: '#:##',
        format: 'H:mm',
        placeholder: '0:00'
    },
    distance: {
        placeholder: '00000',
        min: 0,
        max: 99999
    },
    totalDistance: {
        placeholder: '000000',
        min: 0,
        max: 999999
    },
    rate: {
        mask: '##',
        placeholder: '00',
        min: 0,
        max: 99
    },
    hr: {
        placeholder: '000',
        min: 30,
        max: 250
    },
    lactate: {
        placeholder: '00.00',
        min: 0,
        max: 30
    },
    weight: {
        placeholder: '000',
        min: 35,
        max: 140
    },
    cadence: {
        placeholder: '00',
        min: 0,
        max: 250
    },
    watts: {
        placeholder: '0000.0',
        min: 0,
        max: 3000
    },
    strokeLength: {
        placeholder: '0.00',
        min: 0,
        max: 2.5
    },
    force: {
        placeholder: '000',
        min: 100,
        max: 9999
    },
    forcePosition: {
        placeholder: '00',
        min: 0,
        max: 100
    },
    reps: {
        placeholder: '000',
        min: 0,
        max: 200
    },
    energy: {
        placeholder: '0000',
        min: 0,
        max: 9999
    },
    exercises: {
        weight: {
            placeholder: '000.00',
            min: 0,
            max: 500
        }
    },
    temperature: {
        placeholder: '00.0',
        min: 30,
        max: 47
    }
};

export const SESSION_RESULTS_TYPES = {
    TIME: 'time',
    DISTANCE: 'distance'
};

export const LUDUM_SPORTS = {
    ROWING: 1,
    ERGO: 2,
    BIKE: 3,
    RUN: 4,
    SWIM: 5,
    MULTISPORT: 6,
    SC: 7,
    OTHER: 8,
    DAY_OFF: 9,
    PADDLING: 10,
    INDOOR_PADDLING: 11,
    INDOOR_CYCLING: 12,
    INDOOR_SKIING: 13,
    INDOOR_RUNNING: 14,
    MOUNTAIN_BIKING: 15,
    TRACK_AND_FIELD_RUNNING: 16,
    LAP_SWIMMING: 17,
    LES_MILLS_GRIT_CARDIO: 18,
    CIRCUIT: 19,
    FLEXIBILITY: 20,
    ALPINE_SKIING: 21,
    CROSS_COUNTRY_SKIING: 22,
    BASKETBALL: 23,
    CAMOGIE: 24,
    CROSS_FIT: 25,
    CROSS_TRAINER: 26,
    ELLIPTICAL: 27,
    FIELD_HOCKEY: 28,
    FOOTBALL: 29,
    GAELIC_FOOTBALL: 30,
    HAND_CYCLING: 31,
    HAND_BALL: 32,
    HIKING: 33,
    HURLING: 34,
    ICE_HOCKEY: 35,
    LACROSSE: 36,
    NETBALL: 37,
    RACQUETBALL: 38,
    RUGBY: 40,
    SPINNING: 41,
    SQUASH: 42,
    STAND_UP_PADDLE: 43,
    TENNIS: 44,
    VIRTUAL_RIDE: 45,
    WALKING: 46,
    WHEELCHAIR_RACING: 47,
    PADDLING_FLAT_WATER: 48,
    PADDLING_RESISTED: 49,
    PADDLING_WHITE_WATER: 50,
    PADDLING_WILD_WATER: 51,
    PADDLING_OCEAN: 52,
    KAYAK_CROSS: 53,
    CLIMBING: 54,
    OFF_SEASON: 55
};

export const LUDUM_WALL_POSTS_MODELS = {
    EVENT: 1,
    SQUAD: 3,
    CLUB: 4,
    USER: 5,
    WALL_POST_COMMENT: 6,
    FILE: 7,
    CHALLENGES: 8
};

export const LUDUM_WALL_POSTS_TYPE = {
    WALL_POST: 1,
    COMMENT: 2
};

export const LUDUM_WALL_POST_FILES_MEDIA_TYPES = {
    ALL: 0,
    PHOTO: 1,
    VIDEO: 2,
    DOCUMENT: 3
};

export const LUDUM_SEARCH_GROUPS = {
    ATHLETES: 'athletes',
    SQUADS: 'squads',
    EVENTS: 'events'
};

export const LUDUM_QUICK_ASSIGN_TYPES = {
    ATHLETE: 1,
    COACH: 2,
    SQUAD: 3,
    EVERYBODY: 4
};

export const LUDUM_ATTENDANCE_STATUSES = {
    ATTENDING: 1,
    NOT_ATTENDING: 2
};

export const LUDUM_ILL_TYPES = [1, 2, 3, 4, 5, 6];
export const LUDUM_INJURY_TYPES = [7, 8, 9, 10, 11, 12, 13];

export const OTHER_FOCUSES = [1, 2, 3, 4, 7, 16, 17];
export const SC_FOCUSES = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export const LUDUM_ERROR_CODES = {
    OK: 200,
    PARTIAL_CONTENT: 206,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    FORBIDDEN: 403,
    NO_CLUBS: 419,
    SUBSCRIPTION_EXPIRED: 420,
    INTERNAL_SERVER_ERROR: 500
};

export const LUDUM_ERGO_TYPES = {
    CONCEPT2: 1,
    ROWPERFECT: 2
};

export const LUDUM_CALENDAR_VIEWS = {
    MONTH: 'dayGridMonth',
    WEEK: 'timeGridWeek',
    DAY: 'timeGridDay',
    LIST_VIEW: 'customAgenda',
    WEEKLY_SUMMARY: 'customSummary'
};

export const LUDUM_EQUIPMENT_CATEGORIES = {
    GPS_DEVICES: 1
};
export const LUDUM_EQUIPMENT_ASSIGN_TYPES = {
    USER: 'User',
    CREW: 'Crew',
    Squad: 'Squad'
};

export const LUDUM_CHALLENGES_TARGET_TYPE = {
    DISTANCE: 1,
    TIME: 2,
    NO_OF_STROKES: 3,
    NO_OF_HEARTBEATS: 4,
    DISTANCE_FIRST: 5,
    TIME_FIRST: 6
};

export const LUDUM_UPLOAD_TYPE = {
    CHALLENGE_IMAGE: 'challenge-image',
    CHALLENGE_COVER: 'challenge-cover',
    CLUB_IMAGE: 'club-image',
    PROFILE_IMAGE: 'profile-image'
};

export const FILE_TYPE_MODEL_NAME = {
    CREW: 1,
    INDIVIDUAL: 2
};

export const MINIMAX_TYPES = [
    { id: 'speed', name: 'Vel(100Hz)' },
    { id: 'acceleration_forward', name: 'Acc-fwd' },
    { id: 'cadence', name: 'Stroke' },
    { id: 'velocity', name: 'Vel(gps)' },
    { id: 'horizontal_dilution', name: 'HDOP' },
    { id: 'acceleration_up', name: 'Acc-up' },
    { id: 'acceleration_side', name: 'Acc-side' }
];

export const KEY_CODES = {
    ARROW_DOWN: 40,
    ARROW_UP: 38,
    ARROW_LEFT: 37,
    ARROW_RIGHT: 39,
    ENTER: 13
};

export const GERMAN_INTENSITIES = ['Zone 1', 'Zone 2', 'Zone 3', 'Zone 4', 'Zone 5'];

export const LUDUM_GPS_TYPES = {
    CADENCE: {
        id: 'cadence',
        color: '#16447F',
        lang: 'cadence',
        numberOfDecimals: 0
    },
    HEART_RATE: {
        id: 'heart_rate',
        color: '#E53F47',
        lang: 'hr',
        numberOfDecimals: 0
    },
    POWER: {
        id: 'power',
        color: '#DE7440',
        lang: 'power',
        numberOfDecimals: 1
    },
    PACE: {
        id: 'pace',
        color: '#54BB7B',
        lang: 'pace',
        numberOfDecimals: 1
    },
    SPEED: {
        id: 'speed',
        color: '#54BB7B',
        lang: 'speed',
        numberOfDecimals: 1
    },
    ELEVATION: {
        id: 'elevation',
        color: '#bababa',
        lang: 'elevation',
        numberOfDecimals: 2
    }
};

export const LUDUM_SESSION_IMPORT_FILE_TYPE = {
    GPX: 1,
    FIT: 2,
    TIFF: 3,
    TCX: 4,
    KML: 5,
    XML: 6,
    LZMA: 7,
    FLOAT: 8,
    SUUNTO: 9,
    GARMIN: 10,
    POLAR: 11,
    STRAVA: 12,
    APPLE_HEALTH: 13,
    TELEMETRY: 14
};

export const LUDUM_SESSION_RESULTS_LIVE_STATUSES = {
    IDLE: 1,
    ACTIVE: 2,
    PAUSED: 3,
    FINISHED: 4,
    DISCARD: 5
};

export const LUDUM_SESSION_RESULTS_LIVE_STATUSES_CLASS = {
    [LUDUM_SESSION_RESULTS_LIVE_STATUSES.IDLE]: 'live-results__icon-recording--idle',
    [LUDUM_SESSION_RESULTS_LIVE_STATUSES.ACTIVE]: 'live-results__icon-recording--live',
    [LUDUM_SESSION_RESULTS_LIVE_STATUSES.PAUSED]: 'live-results__icon-recording--paused',
    [LUDUM_SESSION_RESULTS_LIVE_STATUSES.FINISHED]: 'live-results__icon-recording--finished'
};

export const LUDUM_HR_ZONES_COUNT = 6;

export const LUDUM_TRAFFIC_LIGHTS_STATUSES = {
    GRAY: 1,
    GREEN: 2,
    YELLOW: 3,
    RED: 4
};

export const EDIT_CLUB_TABS = {
    CLUB_DETAILS: 'clubDetails',
    CLUB_DEFAULTS: 'clubDefaults',
    HR_ZONES: 'hrZones',
    ROWING_GMT: 'rowingGmt',
    CLUB_USER_CREW_DEFAULTS: 'ClubUserCrewDefaults',
    PADDLING_GMT: 'paddlingGmt',
    ROWING_TELEMETRY: 'rowingTelemetry',
    PADDLING_TELEMETRY: 'paddlingTelemetry',
};

export const GMT_DISTANCE_ROWING = 2000;
export const GMT_DISTANCE_PADDLING = 500;

export const PADDLING_RELATED_SPORTS = [
    LUDUM_SPORTS.PADDLING,
    LUDUM_SPORTS.PADDLING_FLAT_WATER,
    LUDUM_SPORTS.PADDLING_RESISTED,
    LUDUM_SPORTS.PADDLING_WHITE_WATER,
    LUDUM_SPORTS.PADDLING_WILD_WATER,
    LUDUM_SPORTS.PADDLING_OCEAN,
    LUDUM_SPORTS.KAYAK_CROSS
];

export const GMT_DISTRIBUTION_MIN = 50;
export const GMT_DISTRIBUTION_MAX = 120;

export const FILTER_CUSTOM_ID = 'custom-id';

export const LUDUM_DRV_SPORT_GROUPS_COUNT = 4;

export const LUDUM_COMPETITIVE_TYPES = {
    COMPETITIVE_NONE: 0,
    COMPETITIVE_SESSION: 1,
    COMPETITIVE_CREW: 2
};

export const LUDUM_NON_COMPETITIVE_TYPES = [
    LUDUM_COMPETITIVE_TYPES.COMPETITIVE_NONE
]
